// extracted by mini-css-extract-plugin
export var divider = "_oq-0";
export var systemMessage = "_oq-1";
export var systemMessageWrapper = "_oq-2";